module.exports = __webpack_public_path__ + "img/shopIcon3.c1a990d9.png";